import {Routes, Route, useParams, Link, useLocation} from "react-router-dom";
import Listing from "./Listing";
import Header from "../../layouts/Header";
import Icon from "../../components/icon";

import Settings from "./Settings";
import DomainsList from "./DomainsList";
import {Senders} from "./Senders";
import {EnterpriseProvider} from "./EnterpriseProvider";
import EnterpriseForm from "./EnterpriseForm";
import DomainForm from "./DomainForm";


const EnterpriseManager = (props) => {
    const {id} = useParams()
    const location = useLocation();
    const isEnterpriseRoot = location.pathname === '/enterprises';
    const isDomainsList = /^\/enterprises\/[^/]+\/domains$/.test(location.pathname);

    return (
        <>
            <EnterpriseProvider>
                <Header
                    icon="enterprise"
                    title="Enterprise Manager"
                    buttons={[
                        isEnterpriseRoot &&
                        <Link to={'new'} className="btn btn-sm btn-primary">
                            <Icon name="plus"/> <span>Create</span>
                        </Link>,
                        isDomainsList &&
                        <Link to={`/enterprises/${id}/domains/new`} className="btn btn-sm btn-primary">
                            <Icon name="plus"/> <span>Add Domain</span>
                        </Link>,
                    ]}
                />

                <Routes>
                    <Route index element={<Listing/>}/>
                    <Route path="new" element={<EnterpriseForm/>}/>
                    <Route path=":id" element={<EnterpriseForm/>}/>

                    <Route path=":id/settings" element={<Settings/>}/>
                    <Route path=":id/domains" element={<DomainsList/>}/>
                    <Route path=":id/domains/new" element={<DomainForm/>}/>
                    <Route path=":id/domains/:id2" element={<DomainForm/>}/>
                    <Route path=":id/domains/:id2/senders" element={<Senders/>}/>
                </Routes>
            </EnterpriseProvider>
        </>
    )
}

export default EnterpriseManager